/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { PasswordOAuthFlow } from '../../../core/models/common/PasswordOAuthFlow';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';

/**
 * Models an OpenAPI 3.0.x password OAuth flow.
 * 
 * @author eric.wittmann@gmail.com
 * @class
 * @extends PasswordOAuthFlow
 */
export class Oas30PasswordOAuthFlow extends PasswordOAuthFlow {
    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitPasswordOAuthFlow(this);
    }

    constructor() {
        super();
    }
}
Oas30PasswordOAuthFlow["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30PasswordOAuthFlow";
Oas30PasswordOAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




